// Utilities
import querystring from 'querystring';
import { getPath } from '@atc/bonnet-paths';
import cleanMakeModelNames from '@/utilities/cleanMakeModelNames';

const MODEL_INFO_PAGE = 'MODELINFO';
const SRP_BASE_PATH = {
    DEFAULT: '/cars-for-sale/searchresults.xhtml?',
    ALL_CARS: '/cars-for-sale/all-cars?',
    MAX_PRICE: '/cars-for-sale/all-cars/cars-under-',
    USED_MAX_PRICE: '/cars-for-sale/cars-under-',
    NEW_MAX_PRICE: '/cars-for-sale/new-cars/cars-under-',
};

function navigateToPage(url) {
    global.location.assign(url);
}

async function navigateToSRP(params) {

    const friendlySeoUrl = await getPath(
        'srp',
        {
            listingType: params.listingTypes,
            maxPrice: params.price,
            zip: params.zip,
            makeCode: params.selectedMake,
            ...(params.selectedModel && { modelCode: params.selectedModel }),
            ...(params.selectedSeries && { seriesCode: params.selectedSeries }),
            marketExtension: params.marketExtension,
            homeServices: params.homeServices,
        }
    );

    navigateToPage(friendlySeoUrl);
}

function keywordSearchNavigateToSRP(params) {
    // TODO: bonnet - migrate this redirection and pathing code to use Bonnet/router and path

    // mapping object to transform keys for proper SEO query parameter names
    const filterKeyMap = {
        makeCode: 'makeCodeList',
        modelCode: 'modelCodeList',
        trimCode: 'trimCodeList',
        seriesCode: 'seriesCodeList',
        seriesTrimCode: 'seriesTrimCodeList',
    };

    const mappedParams = Object.keys(params).reduce((acc, key) => {
        const mappedKey = filterKeyMap[key] || key;
        acc[mappedKey] = params[key];
        return acc;
    }, {});

    const url = SRP_BASE_PATH.ALL_CARS.concat(querystring.stringify(mappedParams));

    navigateToPage(url);
}

function keywordSearchNavigateToArticlePage(contentUrl) {
    // Need to open in a new tab
    window.open(contentUrl);
}

function navigateToYMMPage(data) {
    const url = [];
    const {
        make: {
            value: makeValue,
            label: makeLabel,
        },
        model: {
            value: modelValue,
            label: modelLabel,
        },
        year: {
            value: yearValue,
            label: yearLabel,
        },
    } = data;

    if (makeValue && makeLabel) {
        url.push(cleanMakeModelNames(makeLabel));
    }
    if (modelValue && modelLabel) {
        url.push(cleanMakeModelNames(modelLabel));
    }
    if (yearValue && yearLabel) {
        url.push(yearValue);
    }
    navigateToPage(`/${url.join('/')}`);
}

export function handleSearchBadgeSubmit(data, pageType) {
    const getSRPParameters = () => {
        const {
            make: {
                value: make,
            },
            model: {
                value: model,
            }, // if series, the URL to SRP must pass seriesCodeList instead of modelCodeList for that particular make
            zip: zipcode,
            listingTypes,
            marketExtension,
            homeServices,
        } = data;

        let seriesValue = null;

        if (model) {
            if (model.includes('CLASS')) {
                seriesValue = model;
            } else if (model.includes('SERIES')) {
                seriesValue = model;
            } else if (model.includes('MODELS')) {
                seriesValue = model;
            }
        }

        return {
            zip: zipcode,
            listingTypes,
            selectedMake: make,
            selectedModel: !seriesValue && model,
            selectedSeries: seriesValue,
            marketExtension,
            homeServices,
        };

    };

    switch (pageType) {

        case MODEL_INFO_PAGE: {
            navigateToYMMPage(data);
            break;
        }
        default: navigateToSRP(getSRPParameters());
    }
}

function handleBudgetSearchSubmit(data) {
    const { pageListingType } = data;
    navigateToSRP(
        {
            ...data,
            zip: null,
            listingTypes: pageListingType || null,
            pageListingType,
            selectedMake: null,
            selectedModel: null,
            selectedSeries: null,
            marketExtension: null,
        }
    );
}

function handleKeywordSearchSubmit(data) {
    const {
        contentUrl = '',
        codes = {},
    } = data;
    if (contentUrl) {
        keywordSearchNavigateToArticlePage(contentUrl);
    } else {
        keywordSearchNavigateToSRP({
            ...codes,
        });
    }
}

export function handleModelInfoSubmit(data) {
    handleSearchBadgeSubmit(data, MODEL_INFO_PAGE);
}

export function handleHomePageKeywordSearchSubmit(data) {
    handleKeywordSearchSubmit(data);
}

export function handleBrowseByBudgetPriceSubmit(data) {
    handleBudgetSearchSubmit(data);
}

export default {
    handleBudgetSearchSubmit,
    handleSearchBadgeSubmit,
};
